import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished } from 'quotes-ui-lib/utils/status';
import useDownloadQuote from 'quotes-ui-lib/hooks/useDownloadQuote';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DownloadButton = ({
  quote,
  trackingLocation,
  templateType,
  buttonRef,
  onLoadingFinish
}) => {
  const [loading, failed, onClick] = useDownloadQuote(quote, trackingLocation, templateType);
  return (
    /*#__PURE__*/
    // Migrate when fixed: https://git.hubteam.com/HubSpot/foundations-components/issues/5923
    _jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.download.downloadInProgress"
      }),
      disabled: !loading,
      children: /*#__PURE__*/_jsx(LoadingButton, {
        buttonRef: buttonRef,
        "data-test-id": "download-quote-btn",
        "data-selenium-test": "download-quote-btn",
        use: "tertiary-light",
        responsive: false,
        onClick: onClick,
        loading: loading,
        onLoadingFinish: onLoadingFinish // Called after the loading spinner animation completes
        ,
        failed: failed,
        disabled: loading,
        spinnerProps: {
          'data-test-id': 'download-button-spinner'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.quoteActions.download.buttonText"
        })
      }, "download-button")
    }, "downloadButtonTooltip")
  );
};
export default DownloadButton;
export const showDownloadButton = quote => {
  return getIsPublished(quote);
};